import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import IdCardGuide from '../../../../../../../shared/components/timeline/IdCardGuide';
import Timelines from '../../../../../../../shared/components/timeline/Timeline';
import { RootState } from '../../../../../../../store';
import { PayerInitialState } from '../../../../../../../store/models/payerListModel';
import { IReimbursementState } from '../../../../../../../store/models/reimbursementModel';
import { getIsPageReimbursement } from '../../../../../../reimbursement/reimbursementUtil';
import { getIsPageNameNewAdmission } from '../../../../service/crmUtils';
import { ID } from '../../../../../../../shared/constants/commonConstants';
import ApplicationDetail from '../../../../../../../shared/services/applicationDetail.service';
import PolicyDetailsGuide from '../../../../../../../shared/components/timeline/PolicyDetailsGuide';
import { isEmpty } from 'lodash';
import { NHCXState } from '../../../../../../../store/models/nhcxModel';
import { getSelectedSearchType } from '../../../../../../../store/actions/newAdmissionAction';
import IPODetailsGuide from '../../../../../../../shared/components/timeline/IPODetailsGuide';

const DetailTimeline = ({ match }: any): any => {
  const { pathname } = useLocation();
  const [flowList, setFlowList] = useState([] as any);
  const details: any = useSelector((state: RootState): any => state.admissionDetails.claimDetails);
  const { reimbursementDetail } = useSelector((state: RootState): IReimbursementState => state?.reimbursement || {});
  const { defaultTimeline, searchType, selectedTab } = useSelector((state: RootState): any => state?.newAdmission);
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const { payer: {shortName, isMemberSearchImageAllowed}, payer} = useSelector((state: RootState): PayerInitialState =>
  state.payerList);
  const {ipoResponse} = useSelector((state: RootState): NHCXState =>
  state.nhcx);
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const dispatch = useDispatch();

  useEffect((): any => {
    if (details?.claimFlowData?.length || reimbursementDetail?.claimFlowData?.length) {
      let claimFlowData = [];
      if (getIsPageReimbursement(pathname)) {
        claimFlowData = reimbursementDetail?.claimFlowData || [];
      } else {
        claimFlowData = details?.claimFlowData || [];
      }
      const localArr: any[] = claimFlowData.map(({
        status: title, remarks: remarks, createdDate: date, documents, hisStatus: hisSyncStatus, isSAClaimFlowData,
        nhcxCorrolationID, hospActionAuditId: flowId, statusId, insurerStatusComment, isFollowUp, followUpcardTitle,
        followUpcardTitleId, followUpSubTitleId,
      }: any): any => ({
        title, remarks, date,
        attachments: documents?.filter(({ isPayerAttachment }: any): boolean => isPayerAttachment) || [],
        hisSyncStatus, isSAClaimFlowData, nhcxCorrolationID, flowId, statusId, insurerStatusComment, isFollowUp,
        followUpcardTitle, followUpcardTitleId, followUpSubTitleId,
      }));
      setFlowList(localArr);
    }
  }, [details, reimbursementDetail]);

  // clearing the searchtype
  useEffect((): any => {
    dispatch(getSelectedSearchType(null));
  }, [payer]);

  return (
    <div>
      <Timelines
        timelineList={flowList?.length > 0 ? flowList : [defaultTimeline]}
      />
      {(isNewAdmissionPage && isMemberSearchImageAllowed ) && ID[shortName][searchType] && // IPP-4405 (adding check based on flag)
      <div className="mt-sm">
        <IdCardGuide />
      </div>
      }
      {isNHCXEnabledProvider && selectedTab === 2 && !isEmpty(ipoResponse) &&
       <><div className="mt-md">
          <PolicyDetailsGuide />
        </div>
        <IPODetailsGuide/>
        </>
      }
    </div>
  );
};

export default withRouter(DetailTimeline);
